<template>
  <!-- Pop up for based on payout -->
  <vs-popup
    :active.sync="shouldBeDisplayed"
    v-if="shouldBeDisplayed"
    vs-lg="12"
    vs-md="12"
    @click="closePopup()"
    classContent="payout-details-modal-wrapper"
    button-close-hidden>
    <header>
      <h1>Payout Details</h1>
      <button
        class="cancel"
        @click="openCancelPopup()"
        v-if="
          selectedPayoutGetter.status === PAYOUT_STATUS.NEW.value && hasRightsToCancel
        ">
        Cancel this payout
      </button>
      <button
        class="email"
        @click="openEmailPopup()"
        v-if="
          selectedPayoutGetter.status === PAYOUT_STATUS.NEW.value && hasRightsToEmail
        ">
        Resend/Change email
      </button>
      <button @click="closePopup()" class="btn">X</button>
    </header>
    <dl>
      <div>
        <dt>Payout Reference</dt>
        <dd>{{ selectedPayoutGetter.payout_reference }}</dd>
      </div>
      <div>
        <dt>Status</dt>
        <dd><tag>{{ PAYOUT_STATUS[selectedPayoutGetter.status.toUpperCase()].display }}</tag></dd>
      </div>
      <div>
        <dt>Transaction Date</dt>
        <dd>
          {{ formatToLocalDate(selectedPayoutGetter.payout_date) }},
          {{ formatToLocalTime(selectedPayoutGetter.payout_date) }}
        </dd>
      </div>
      <div>
        <dt>Last modified</dt>
        <dd>
          {{ formatToLocalDate(selectedPayoutGetter.status_date) }},
          {{ formatToLocalTime(selectedPayoutGetter.status_date) }}
        </dd>
      </div>
      <div v-if="isStatusDoneOrConfirm(selectedPayoutGetter.status)">
        <dt>Payout type</dt>
        <dd>{{ getFromAndToCurrencies(selectedPayoutGetter) }}</dd>
      </div>
      <div
        v-if="
          isStatusDoneOrConfirm(selectedPayoutGetter.status) &&
          selectedPayoutGetter.account_type != 'custody'
        ">
        <dt>
          Exchange rate ({{
          selectedPayoutGetter.crypto_currency === 'LNBC'
          ? 'sats'
          : selectedPayoutGetter.crypto_currency.split('_')[0]
          }}/{{ selectedPayoutGetter.payout_currency }})
        </dt>
        <dd>
          {{
          selectedPayoutGetter.crypto_currency === 'LNBC'
          ? formatCryptoPrice(selectedPayoutGetter.display_exchange_rate)
          : formatExchangeRateValue(selectedPayoutGetter.display_exchange_rate)
          }}
        </dd>
      </div>
      <div>
        <dt>Withdraw Amount</dt>
        <dd v-if="selectedPayoutGetter.convert_type === 'local-crypto'">
          {{ formatFiatPrice(selectedPayoutGetter.debit_amount) }}
          {{ selectedPayoutGetter.payout_currency }}
        </dd>
        <dd v-else-if="selectedPayoutGetter.account_type === 'custody'">
          {{
          getFormattedCryptoPrice(
          selectedPayoutGetter.crypto_currency,
          selectedPayoutGetter.crypto_amount
          )
          }}
        </dd>
        <dd v-else>
          {{
          getFormattedCryptoPrice(
          selectedPayoutGetter.crypto_currency,
          selectedPayoutGetter.withdraw_amount
          )
          }}
        </dd>
      </div>
      <div
        v-if="
          selectedPayoutGetter &&
          isStatusDoneOrConfirm(selectedPayoutGetter.status) &&
          selectedPayoutGetter.convert_type !== 'custody-crypto'
        ">
        <dt>Received by payee (before tax)</dt>
        <dd>
          {{
          selectedPayoutGetter
          ? `${formatFiatPrice(selectedPayoutGetter.payee_amount)} ${
          selectedPayoutGetter.payout_currency
          }`
          : '-'
          }}
        </dd>
      </div>
      <div
        v-if="
          (isStatusDoneOrConfirm(selectedPayoutGetter.status) &&
            selectedPayoutGetter.status === PAYOUT_STATUS.CONFIRM.value) ||
          selectedPayoutGetter.status === PAYOUT_STATUS.DONE.value
        ">
        <dt>Net crypto amount received by payee</dt>
        <dd>
          {{
          getFormattedCryptoPrice(
          selectedPayoutGetter.crypto_currency,
          selectedPayoutGetter.net_crypto_amount
          )
          }}
        </dd>
      </div>
      <div v-if="isStatusDoneOrConfirm(selectedPayoutGetter.status)">
        <dt>Network fee</dt>
        <dd>
          {{
          getFormattedCryptoPrice(
          selectedPayoutGetter.crypto_currency,
          selectedPayoutGetter.network_fee_crypto_amount
          )
          }}
        </dd>
      </div>
      <div v-if="selectedPayoutGetter.account_type != 'custody'">
        <dt>
          Total fee
          <span class="tooltip">
            <img src="../../assets/icons/help.svg" alt="more info on fees" />
            <span class="tooltip-text">
              <strong>GST inclusive if applicable</strong> (merchants
              incorporated in Singapore)
            </span>
          </span>
        </dt>
        <dd>
          {{
          selectedPayoutGetter.fiat_amount_fee +
          selectedPayoutGetter.vat_fiat_amount
          }}
          {{ selectedPayoutGetter.payout_currency }}
        </dd>
      </div>
      <div>
        <dt>Order Id</dt>
        <dd>
          {{
          selectedPayoutGetter.payee_order_id ? selectedPayoutGetter.payee_order_id : '-'
          }}
        </dd>
      </div>
      <div>
        <dt>Batch Id</dt>
        <dd>{{ selectedPayoutGetter.payout_batch_key ? selectedPayoutGetter.payout_batch_key : '-' }}</dd>
      </div>
      <div>
        <dt>Remarks</dt>
        <dd>
          {{ selectedPayoutGetter.status_remarks }}
          <br
            v-if="
              selectedPayoutGetter.status_remarks &&
              selectedPayoutGetter.payee_remarks
            " />
          {{ selectedPayoutGetter.payee_remarks }}
        </dd>
      </div>
    </dl>
    <section>
      <h2>Payee's information</h2>
      <dl>
        <div>
          <dt>Payee's Email</dt>
          <dd>{{ selectedPayoutGetter.payee_email }}</dd>
        </div>
        <div>
          <dt>Payee's name</dt>
          <dd>{{ selectedPayoutGetter.payee_name }}</dd>
        </div>
        <div>
          <dt>Payee's wallet address</dt>
          <dd>
            {{
            selectedPayoutGetter.crypto_address
            ? selectedPayoutGetter.crypto_address
            : '-'
            }}
          </dd>
        </div>
        <div>
          <dt>Payee's country</dt>
          <dd>{{ selectedPayoutGetter.payee_country }}</dd>
        </div>
      </dl>
    </section>

    <section>
      <h2>Payout Creation and Approver Details</h2>
      <dl>
        <div>
          <dt>Payout created by:</dt>
          <dd>{{ selectedPayoutGetter.created_by }}</dd>
        </div>
        <div>
          <dt>Creation timestamp</dt>
          <dd>
            {{ formatToLocalDate(selectedPayoutGetter.created_at) }}
            {{ formatToLocalTime(selectedPayoutGetter.created_at) }}
          </dd>
        </div>
        <div>
          <dt>Approved by:</dt>
          <template v-for="payoutApprover in selectedPayoutGetter.approvers">
            <dd
              v-if="payoutApprover"
              :key="payoutApprover && payoutApprover.email">
              {{ payoutApprover && payoutApprover.email }}
            </dd>
          </template>
        </div>
        <div>
          <dt>Approval timestamps</dt>
          <template v-for="payoutApprover in selectedPayoutGetter.approvers">
            <dd
              v-if="payoutApprover"
              :key="payoutApprover && payoutApprover.email">
              {{ formatToLocalDate(payoutApprover.approved_at) }}
              {{ formatToLocalTime(payoutApprover.approved_at) }}
            </dd>
          </template>
        </div>
        <div>
          <dt>Approvals required at creation</dt>
          <dd>{{ selectedPayoutGetter.approval_total }}</dd>
        </div>
      </dl>
    </section>
  </vs-popup>
</template>

<script>
import { mapGetters } from 'vuex';
import Tag from '../../atoms/Tag.vue';
import { CRYPTO_PAYOUT_STATUS } from '../../constants';

export default {
  components: { Tag },
  name: 'PayoutDetailsPopup',
  props: ['shouldDisplay'],
  data() {
    return {
      debugConsole: false,
      shouldBeDisplayed: this.shouldDisplay,
      hasRightsToCancel: false,
      hasRightsToEmail: false,
      hasRightsToChangeEmail: false,
      PAYOUT_STATUS: CRYPTO_PAYOUT_STATUS,
    };
  },
  mounted() {
    if (!this.transaction) {
      this.displayPopup = false;
    }
    window.addEventListener('keyup', this.closePopupEscKey); // Add 'keyup' event to the popup
    window.addEventListener('keyup', this.closePopupEscKeyAddress);
  },
  updated() {
    if (!this.shouldBeDisplayed) {
      // to close the popup properly of user clicks beside it to close
      this.closePopup();
    }
  },
  computed: {
    ...mapGetters([
      'activeMerchantGetter',
      'activeAccountGetter',
      'selectedPayoutGetter',
      'currentActiveEntityAdminGetter',
      'listOfEntityAdminGetter',
    ]),

    getSettlementType() {
      return this.$store.getters.activeAccountGetter.settlementType;
    },

    getEntityAdminMap() {
      return this.listOfEntityAdminGetter.reduce(
        (entityAdminMap, entityAdmin) =>
          entityAdminMap.set(entityAdmin.id, entityAdmin),
        new Map()
      );
    },
  },
  watch: {
    shouldDisplay(newValue) {
      this.shouldBeDisplayed = newValue;
      if (this.shouldBeDisplayed) this.getRights();
    },
    selectedPayoutGetter(newVal) {
      this.shouldBeDisplayed = Boolean(newVal) && this.shouldDisplay;
      this.getRights();
    },
  },
  beforeDestroy() {
    window.removeEventListener('keyup', this.closePopupEscKey); // Remove 'keyup' event to the popup
    window.removeEventListener('keyup', this.closePopupEscKeyAddress);
  },
  methods: {
    getRights() {
      const currentActiveMerchantId =
        this.activeMerchantGetter && this.activeMerchantGetter.id;
      //determine to show if the user has permission to cancel a payout or not
      this.hasRightsToCancel = this.isAllowed(
        this.currentActiveEntityAdminGetter,
        currentActiveMerchantId,
        'payout_links',
        'D'
      );
      this.hasRightsToEmail = this.isAllowed(
        this.currentActiveEntityAdminGetter,
        currentActiveMerchantId,
        'payout_links',
        'R'
      );
      this.hasRightsToChangeEmail = this.isAllowed(
        this.currentActiveEntityAdminGetter,
        currentActiveMerchantId,
        'payout_links',
        'W'
      );
    },
    openCancelPopup() {
      this.$emit('cancel-clicked');
    },
    openEmailPopup() {
      this.$emit('email-clicked');
    },
    closePopup() {
      this.$emit('close-details-modal');
    },
    getFormattedCryptoPrice(currency, amount) {
      if (currency === 'LNBC') {
        return `${amount} sats`;
      } else {
        return `${this.formatCryptoAmount(amount, currency)} ${currency}`;
      }
    },
    getFromAndToCurrencies(pyt) {
      let fromCurr = '';
      let toCurr = '';
      const destinationType = pyt.convert_type.split('-')[1];
      if (pyt.account_type === 'custody') {
        fromCurr = pyt.crypto_currency;
      } else {
        fromCurr = pyt.payout_currency;
      }
      if (destinationType === 'local') {
        toCurr = pyt.payout_currency;
      } else {
        toCurr = pyt.crypto_currency;
      }

      return `From ${fromCurr} to ${toCurr}`;
    },
    isStatusDoneOrConfirm(status) {
      return status === this.PAYOUT_STATUS.DONE.value || status === this.PAYOUT_STATUS.CONFIRM.value;
    },
  },
};
</script>

<style lang="scss">
.payout-details-modal-wrapper {
  padding: 24px 24px 24px 40px !important;

  header {
    display: flex;
    margin-bottom: 12px;

    button {
      height: 32px;
      width: 32px;
      border: none;
      border-radius: 10px;
      margin-left: auto;
      transition: ease-in-out 0.2s;

      &:hover {
        background-color: rgb(174, 174, 174);
        cursor: pointer;
      }

      &.cancel {
        width: auto;
        color: white;
        background-color: #ca2828;
        border-radius: 6px;
        padding: 0 10px;
        margin-left: 24px;

        &:hover {
          background-color: #8c2222;
        }
      }

      &.email {
        width: auto;
        color: white;
        background-color: rgb(7, 85, 147);
        border-radius: 6px;
        padding: 0 10px;
        margin-left: 12px;

        &:hover {
          cursor: pointer;
          background-color: rgb(5, 59, 102);
        }
      }
    }
  }

  dl {
    display: flex;
    flex-wrap: wrap;

    & > div {
      width: 50%;
      margin-bottom: 16px;
      padding-right: 12px;
      min-width: 300px;
      max-width: 380px;

      dt {
        font-weight: 700;
        color: #505050;
        text-transform: capitalize;

        .tooltip {
          position: relative;
          text-align: center;
          img {
            position: relative;
            height: 16px;
            width: 16px;
            top: 3px;
          }
          .tooltip-text {
            text-align: center;
            visibility: hidden;
            position: absolute;
            background: #efefef;
            padding: 6px 4px;
            border-radius: 3px;
            font-size: 12px;
            max-width: 550px;
            min-width: 200px;
            white-space: normal;
            font-weight: normal;
            top: -10px;
            & > span {
              font-weight: bold;
            }
          }

          &:hover {
            .tooltip-text {
              visibility: visible;
            }
          }
        }
      }

      dd {
        line-break: anywhere;
      }

      &.remarks {
        width: 100%;
      }

      &.order-id {
        width: 100%;
      }
    }
  }

  h2 {
    margin-bottom: 12px;
  }
  .payment-details {
    margin-top: 24px;
  }
}

/* CUSTOMISED SCROLLBAR */
/*===========================*/
.vs-popup--content::-webkit-scrollbar {
  width: 10px;
}

.vs-popup--content::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}
</style>
